// extracted by mini-css-extract-plugin
export default {"link":"link--wQkhC","svgLeft":"svgLeft--Irq90","linkActive":"linkActive--_g79x","svg":"svg--dFKsz","svgRotate":"svgRotate--wjMV_","title":"title--TlpSD","button":"button--ibCfK"};